import secondaryComponents from "../../../../../components/secondaryComponents";
import primaryComponents from "../../../../../components/primaryComponents";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "./ReturnReview.module.scss";

export const ReturnReviewActions = ({
  isPending = false,
  isApproving = false,
  isRejecting = false,
  setIsApproveModalOpen,
  setIsRejectModalOpen,
  onApprove,
  onReject,
  className = "",
  style,
}) => {
  if (!isPending) return null;

  const handleApprove = () => {
    if (onApprove) {
      onApprove();
    } else if (setIsApproveModalOpen) {
      setIsApproveModalOpen(true);
    }
  };

  const handleReject = () => {
    if (onReject) {
      onReject();
    } else if (setIsRejectModalOpen) {
      setIsRejectModalOpen(true);
    }
  };

  return (
    <secondaryComponents.NavigateWithPermission
      permissionParentKey="Inventory Management"
      permissionChildKey="can_approve_returns"
    >
      <div
        className={`${styles.returnReview__actions} ${className}`.trim()}
        style={style}
      >
        <primaryComponents.Button
          classNames="btn btn--outline-red"
          onClick={handleReject}
          isDisabled={isRejecting || isApproving}
        >
          <FontAwesomeIcon icon="times" className="mr-2" />
          Reject
        </primaryComponents.Button>

        <primaryComponents.Button
          classNames="btn btn--primary"
          onClick={handleApprove}
          isDisabled={isApproving || isRejecting}
        >
          <FontAwesomeIcon icon="check" className="mr-2" />
          Approve
        </primaryComponents.Button>
      </div>
    </secondaryComponents.NavigateWithPermission>
  );
};

export default ReturnReviewActions;
